import styled from "styled-components";
import {ConstantsStyles} from "@dropDesk/domain/entities/constants/constants_keys";
import {hexToRGBA} from "@dropDesk/utils/helpers/colors";
import {
    ContainerType,
    ContentType,
    ChipItemType,
    ChipTextType, ChipRemoveIconType, ContainerChipRemoveIconType
} from "@dropDesk/presentation/components/inputs/input_chips/input_chips_border";

export const Container = styled.div<ContainerType>`
    display: flex;
    flex-direction: column;
    margin-left: ${(props) => `${props.marginLeft}px`};
    margin-top: ${(props) => `${props.marginTop}px`};
    min-width: 100%;
    position: relative;
`;

export const Content = styled.div<ContentType>`
    min-height: ${(props) => `${props.size}px`};
    max-height: 300px;
    overflow-y: auto;
    min-width: 100%;
    background: ${(props) => props.background};
    display: flex;
    border-radius: ${(props) => props.usedBorder ? `${ConstantsStyles.radiusButton}px` : 0};
    align-items: center;
    padding: 0 0 0 5px;
    cursor: ${props => props.disabled ? 'no-drop' : 'auto'};
    border: ${props => props.usedBorder ? `1px solid ${props.border}` : 'auto'};
    border-bottom: ${props => !props.usedBorder ? `1px solid ${props.border}` : 'auto'};
    cursor: pointer;

    &:hover {
        border-color: transparent;
        box-shadow: ${props => props.usedBorder ? `0 0 0 2px ${hexToRGBA(props.accent, .58)}` : `0 4px 2px -2px ${hexToRGBA(props.accent, 0.58)}`};
        outline: none;
        transition: box-shadow .3s ease-out .1s, border .3s ease-out, border-radius .3s ease-out, background-color .2s ease-out, color .2s ease-out, transform .2s ease-out;
    }

    &:focus-within {
        border-color: transparent;
        box-shadow: ${props => props.usedBorder ? `0 0 0 2px ${hexToRGBA(props.accent, .58)}` : `0 4px 2px -2px ${hexToRGBA(props.accent, 0.58)}`};
        outline: none;
        transition: box-shadow .3s ease-out .1s, border .3s ease-out, border-radius .3s ease-out, background-color .2s ease-out, color .2s ease-out, transform .2s ease-out;
    }
`;

export const ContainerChips = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    flex: 1;
    padding: 4px;
    align-items: center;
`;

export const Chip = styled.div<ChipItemType>`
    display: flex;
    align-items: center;
    background: ${props => props.background};
    border: 1px solid ${props => props.border};
    border-radius: ${ConstantsStyles.radiusButton}px;
    padding: 0 8px;
    height: 30px;
    max-height: 30px;
    min-height: 30px;
    gap: 6px;
    max-width: 200px;
`;

export const ChipText = styled.span<ChipTextType>`
    font-size: 13px;
    color: ${props => props.color};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;
`;

export const ChipRemoveIcon = styled.div<ContainerChipRemoveIconType>`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: ${props => props.color};
    border-radius: 50%;
    width: 18px;
    
    &:hover {
        background: ${props => props.background};
        border-color: transparent;
        box-shadow: 0 0 0 2px ${props => hexToRGBA(props.accent, .58)};
        outline: none;
        transition: box-shadow .3s ease-out .1s, border .3s ease-out, border-radius .3s ease-out, background-color .2s ease-out, color .2s ease-out, transform .2s ease-out;
    }

`;
